/* eslint-disable import/no-cycle,no-use-before-define */
import { actAuditCertificationListFetch } from 'actions/auditCertificationActions';
import { actBibleListFetch } from 'actions/bibleActions';
import { actProductCategoryListFetch } from 'actions/productCategoryActions';
import { actTagsFetch } from 'actions/tagsActions';
import fetch from 'cross-fetch';
import {
  ApiV1Base,
  ApiPrefix,
  getCookie,
  ApiBase,
  json,
  statusCheck,
  checkToGetErrorResponse,
  setCookie,
  setDocumentCookie,
  setLanguageLocale,
} from 'util/icwUtility';
import { clearLS } from 'util/localStorageProvider';
import configureI18n from 'helpers/i18n';
import T from 'i18n-react';
import { actAnyFieldUpdate } from './formActions';
import { actNotificationAdd } from './notificationActions';
import { actWechatLogin } from './wechatLoginActions';

export const LOGIN_INIT = 'LOGIN_INIT';
export function actLoginInit() {
  return { type: LOGIN_INIT };
}

export const AUTHENTICATE_USER_BEGIN = 'AUTHENTICATE_USER_BEGIN';
function actAuthenticateUserBegin() {
  return { type: AUTHENTICATE_USER_BEGIN };
}

export const AUTHENTICATE_USER_SUCCESS = 'AUTHENTICATE_USER_SUCCESS';
export function actAuthenticateUserSuccess() {
  return { type: AUTHENTICATE_USER_SUCCESS };
}

export const AUTHENTICATE_USER_FAIL = 'AUTHENTICATE_USER_FAIL';
function actAuthenticateUserFail(reason, errResponse) {
  return { type: AUTHENTICATE_USER_FAIL, reason, errResponse };
}

export function actAuthenticateUser(email, password, isAli) {
  return (dispatch) => {
    dispatch(actAuthenticateUserBegin());
    return fetch(`${ApiV1Base}${ApiPrefix}/auth/login`, {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    })
      .then(checkToGetErrorResponse)
      .then(json)
      .then((res) => {
        const { token, isActivated = true } = res; // activated by default
        setCookie('token', token);
        setCookie('adminToken', token);
        setCookie('activated_user', isActivated);

        dispatch(actAuthenticateUserSuccess());
        dispatch(
          actNotificationAdd({
            variant: 'success',
            message: 'loginSuccess',
          })
        );
      })
      .catch((err) => {
        dispatch(actAuthenticateUserFail('invalidEmailPassword', null));
        dispatch(
          actNotificationAdd({
            variant: 'error',
            message: 'loginFail',
          })
        );
        throw err;
      });
  };
}

export const USER_PROFILE_FETCH_BEGIN = 'USER_PROFILE_FETCH_BEGIN';
export function actUserProfileFetchBegin() {
  return { type: USER_PROFILE_FETCH_BEGIN };
}

export const USER_PROFILE_FETCH_SUCCESS = 'USER_PROFILE_FETCH_SUCCESS';
function actUserProfileFetchSuccess(profile, status) {
  return { type: USER_PROFILE_FETCH_SUCCESS, profile, status };
}

export const USER_PROFILE_FETCH_FAIL = 'USER_PROFILE_FETCH_FAIL';
function actUserProfileFetchFail(reason, errResponse) {
  return { type: USER_PROFILE_FETCH_FAIL, reason, errResponse };
}

export function actUserProfileFetch(status) {
  return (dispatch) => {
    dispatch(actUserProfileFetchBegin());
    return fetch(`${ApiV1Base}${ApiPrefix}/user/me`, {
      headers: { Authorization: getCookie('token') },
    })
      .then(statusCheck)
      .then(json)
      .then((data) => {
        dispatch(actUserProfileFetchSuccess(data, status));
      })
      .catch((err) => {
        dispatch(
          actUserProfileFetchFail(
            'invalidEmailPassword',
            typeof err === 'object' ? err.message : err
          )
        );
      });
  };
}

const LOGIN_BEGIN = 'LOGIN_BEGIN';
export function actLoginBegin() {
  return { type: LOGIN_BEGIN };
}

const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export function actLoginSuccess() {
  return { type: LOGIN_SUCCESS };
}

const LOGIN_FAIL = 'LOGIN_FAIL';
function actLoginFail(reason, errResponse) {
  return { type: LOGIN_FAIL, reason, errResponse };
}

export function actLogin(email, password, status) {
  return (dispatch) => {
    dispatch(actLoginBegin());
    return dispatch(actAuthenticateUser(email, password))
      .then(() =>
        Promise.all([
          dispatch(actUserProfileFetch(status)),
          dispatch(actAuditCertificationListFetch()),
          dispatch(actBibleListFetch()),
          dispatch(actProductCategoryListFetch()),
          dispatch(actTagsFetch()),
        ])
      )
      .then(([userData, ...rest]) => {
        dispatch(actLoginSuccess());
        // dispatch(actWechatLogin(userData));
      })
      .catch(() => dispatch(actLoginFail()));
  };
}

export const LOGOUT = 'LOGOUT';
export function actLogout(cookies) {
  cookies.remove('token', { path: '/' });
  cookies.remove('adminToken', { path: '/' });
  cookies.remove('wechatToken', { path: '/' });
  cookies.remove('activated_user', { path: '/' });

  // clear localStorage when logout
  clearLS();

  return { type: LOGOUT };
}

export const LOGIN_TIMED_OUT = 'LOGIN_TIMED_OUT';
export function actLoginTimedOut() {
  return { type: LOGIN_TIMED_OUT };
}

export const LOGIN_CHECK_BEGIN = 'LOGIN_CHECK_BEGIN';
function actLoginCheckBegin() {
  return { type: LOGIN_CHECK_BEGIN };
}

export const LOGIN_CHECK_FAIL = 'LOGIN_CHECK_FAIL';
function actLoginCheckFail(reason) {
  return { type: LOGIN_CHECK_FAIL, reason };
}

export function actLoginCheck() {
  return (dispatch) => {
    dispatch(actLoginCheckBegin());
    return fetch(`${ApiBase}${ApiPrefix}/auth/loginCheck`, {
      method: 'POST',
    })
      .then(statusCheck)
      .then(json)
      .then((res) => {
        setDocumentCookie(`token=${res.token}`);
      })
      .catch((err) => {
        dispatch(actLoginCheckFail(typeof err === 'object' ? err.message : err));
      });
  };
}

//
//  ******* Profile Setup Status Check Related *******
//

export const COMPANY_PROFILE_SETUP_STATUS_CHECK_SUCCESS =
  'COMPANY_PROFILE_SETUP_STATUS_CHECK_SUCCESS';
export function actCompanyProfileSetupStatusCheckSuccess(data) {
  return { type: COMPANY_PROFILE_SETUP_STATUS_CHECK_SUCCESS, data };
}

export const COMPANY_PROFILE_SETUP_STATUS_CHECK_FAIL = 'COMPANY_PROFILE_SETUP_STATUS_CHECK_FAIL';
export function actCompanyProfileSetupStatusCheckFail(reason) {
  return { type: COMPANY_PROFILE_SETUP_STATUS_CHECK_FAIL, reason };
}

export function actCompanyProfileSetupStatusCheck(cb) {
  return (dispatch) =>
    fetch(`${ApiBase}${ApiPrefix}/companies/profile/setup/status`, {
      method: 'GET',
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then(statusCheck)
      .then(json)
      .then((jsonData) => {
        dispatch(actCompanyProfileSetupStatusCheckSuccess(jsonData));
        if (cb) cb();
      })
      .catch((err) => {
        if (err.status === 401) {
          dispatch(actLoginTimedOut());
        }

        dispatch(
          actCompanyProfileSetupStatusCheckFail(typeof err === 'object' ? err.message : err)
        );
      });
}

//
// ********* Reset Password
//

export const USER_RESET_PASSWORD_BEGIN = 'USER_RESET_PASSWORD_BEGIN';
export function actUserResetPasswordBegin() {
  return { type: USER_RESET_PASSWORD_BEGIN };
}

export function actResetPassword(email, locale) {
  return (dispatch, getState) => {
    dispatch(actUserResetPasswordBegin());
    return fetch(`${ApiBase}${ApiPrefix}/auth/resetPassword`, {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, locale }),
    })
      .then(statusCheck)
      .then((res) => dispatch(actUserResetPasswordSuccess()))
      .catch((err) => {
        dispatch(actUserResetPasswordFail(typeof err === 'object' ? err.message : err));
      });
  };
}

export const USER_RESET_PASSWORD_SUCCESS = 'USER_RESET_PASSWORD_SUCCESS';
export function actUserResetPasswordSuccess() {
  return { type: USER_RESET_PASSWORD_SUCCESS };
}

export const USER_RESET_PASSWORD_FAIL = 'USER_RESET_PASSWORD_FAIL';
export function actUserResetPasswordFail(reason) {
  return { type: USER_RESET_PASSWORD_FAIL, reason };
}

//
// ******** Check Token
//

export const USER_CHECK_TOKEN_BEGIN = 'USER_CHECK_TOKEN_BEGIN';
export function actUserCheckTokenBegin() {
  return { type: USER_CHECK_TOKEN_BEGIN };
}

export const USER_VALID_TOKEN_SUCCESS = 'USER_VALID_TOKEN_SUCCESS';
export function actUserCheckValidTokenSuccess() {
  return { type: USER_VALID_TOKEN_SUCCESS };
}

export const USER_VALID_TOKEN_FAIL = 'USER_VALID_TOKEN_FAIL';
export function actUserCheckValidTokenFail(reason) {
  return { type: USER_VALID_TOKEN_FAIL, reason };
}

export function actUserCheckToken(token) {
  return (dispatch) => {
    dispatch(actUserCheckTokenBegin());
    fetch(`${ApiBase}${ApiPrefix}/auth/checkValidToken/${token}`, {
      method: 'GET',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    })
      .then(statusCheck)
      .then(() => {
        dispatch(actUserCheckValidTokenSuccess());
      })
      .catch((err) => {
        dispatch(actUserCheckValidTokenFail(typeof err === 'object' ? err.message : err));
      });
  };
}

//
// ******* Change Password
//

export const USER_CHANGE_PASSWORD_BEGIN = 'USER_CHANGE_PASSWORD_BEGIN';
export function actUserChangePasswordBegin() {
  return { type: USER_CHANGE_PASSWORD_BEGIN };
}
export const USER_CHANGE_PASSWORD_SUCCESS = 'USER_CHANGE_PASSWORD_SUCCESS';
export function actUserChangePasswordSuccess() {
  return { type: USER_CHANGE_PASSWORD_SUCCESS };
}
export const USER_CHANGE_PASSWORD_FAIL = 'USER_CHANGE_PASSWORD_FAIL';
export function actUserChangePasswordFail() {
  return { type: USER_CHANGE_PASSWORD_FAIL };
}

export function actChangePassword(token, password, confirmPassword) {
  return (dispatch, getState) => {
    dispatch(actUserChangePasswordBegin());
    fetch(`${ApiBase}${ApiPrefix}/auth/updatePassword`, {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({
        token,
        password,
        confirmPassword,
      }),
    })
      .then(statusCheck)
      .then((res) => {
        dispatch(actUserChangePasswordSuccess());
      })
      .catch((err) => {
        dispatch(actUserChangePasswordFail(typeof err === 'object' ? err.message : err));
      });
  };
}

export function actQuickRegistration(data) {
  return (dispatch, getState) => {
    dispatch(actAnyFieldUpdate('loginState', ['status'], 'begin'));
    fetch(`${ApiBase}${ApiPrefix}/user/create`, {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: data.email,
        password: data.password,
        company_name: data.companyName,
      }),
    })
      .then(json)
      .then((res) => {
        if (res && res.emailExists) {
          dispatch(actAnyFieldUpdate('loginState', ['status'], 'emailExists'));
          dispatch(actAnyFieldUpdate('loginState', ['failReason'], 'emailExists'));
        } else {
          dispatch(actLogin(data.email, data.password, 'submitting'));
        }
      })
      .catch((err) => {
        dispatch(actAnyFieldUpdate('loginState', ['failReason'], 'invalidEmailPassword'));
        dispatch(actUserChangePasswordFail());
      });
  };
}

//
// ******* Change Language
//
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
export function actChangeLanguage(cookies, lang) {
  cookies.remove('locale', { path: '/' });
  cookies.set('locale', lang, { path: '/' });

  return { type: CHANGE_LANGUAGE };
}
